import { useContext, useEffect } from "react";
import Application from "../../components/application";
import Button from "@mui/material/Button";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import useCursosState from "../../hooks/useCursosState";
import VideoSettingsIcon from '@mui/icons-material/VideoSettings';
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import { useNavigate } from "react-router-dom";
import GridView from "../../components/views/gridView";
import {Tooltip} from "@mui/material";
import TELAS from "../../constants/telas";
import TELA_ACOES from "../../constants/telaAcoes";
import permissaoTelas from "../../utils/permissaoTelas";
import { AuthContext } from "../../contexts/auth";


const PAGINA = {
    aplicacao: 'SisPalo - Colaborador',
    funcionalidade: 'Cursos',
    tela: TELAS.CURSOS,
    acoes: [TELA_ACOES.Incluir,TELA_ACOES.Consultar,TELA_ACOES.Alterar, TELA_ACOES.Apagar]
}

const Cursos = () => {

    const states = useCursosState()
    const navigate = useNavigate()
    const {permissaoUsuario} = useContext(AuthContext); /* permissão para telas*/    

    /* permissão para telas*/
    useEffect(()=>{
        if (permissaoTelas(permissaoUsuario, TELA_ACOES.Consultar, PAGINA)){
            if (states.pesquisa.value === ''){
                states.submit.set()
            }
        }
        else {
            navigate('/gestor/dashboard')
        }

    }, [])

    useEffect(()=>{
        if (states.pesquisa.value === ''){
            states.submit.set()
        }

    }, [states.pesquisa.value])

    

    const columns = [
        //{field:'id', headerName:'ID', width: 80},
        {field:'name', headerName:'Nome Curso', flex: 1},
        {field:'numero_videos', headerName:'Videos', width: 100},
        {filed:'', headerName:'Ações', width:110, renderCell: (cellValues) =>{
            return (
                <>
                
                    <Tooltip title="Apagar" placement="bottom" arrow>
                        <Button color='error' 
                        disabled={!permissaoTelas(permissaoUsuario, TELA_ACOES.Apagar, PAGINA) || cellValues.row.numero_videos > 0} 
                        onClick={()=>{states.itemDelete.set(cellValues.row);states.openDialog.set(true)}} sx={{width:'55px', padding: 0,minWidth:0}}><DeleteIcon /></Button>
                    </Tooltip>
                    <Tooltip title="Permissão" placement="bottom" arrow>
                        
                        <Button disabled={!permissaoTelas(permissaoUsuario, TELA_ACOES.Alterar, PAGINA)}
                        onClick={()=>navigate(`/gestor/curso/${cellValues.row.id}/permissao`)} sx={{width:'55px', padding: 0,minWidth:0}}><SettingsApplicationsIcon /></Button>
                        
                    </Tooltip>
                    <Tooltip title="Editar" placement="bottom" arrow>
                            <Button disabled={!permissaoTelas(permissaoUsuario, TELA_ACOES.Alterar, PAGINA)}
                            onClick={()=>navigate(`/gestor/curso/${cellValues.row.id}`)} sx={{width:'55px', padding: 0,minWidth:0}}><EditIcon /></Button>
                        
                    </Tooltip>
                    <Tooltip title="Videos" placement="bottom" arrow>
                            <Button disabled={!permissaoTelas(permissaoUsuario, TELA_ACOES.Consultar, PAGINA)}
                            onClick={()=>navigate(`/gestor/curso/${cellValues.row.id}/videos`)} sx={{width:'55px', padding: 0,minWidth:0}}><VideoSettingsIcon /></Button>
                        
                    </Tooltip>
                </>
                
            )
        }}
    ]
    
    return (
   
        <Application>
            <>
                <GridView 
                    title='Cursos' 
                    states={states}
                    rows={states.cursos.value}
                    columns={columns}
                    urlAdd={permissaoTelas(permissaoUsuario, TELA_ACOES.Incluir, PAGINA) ? `/gestor/curso` : null}
                    urlVoltar={'/gestor/dashboard'}                    
                    onClickPesquisa={()=>{states.submit.set()}}
                    nomeItem='curso'
                    modalAdd={null}
                />
            </>
        </Application>
   
    )
}

export default Cursos;